<template>
    <div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li>
              <router-link :to="{ name: 'Media Pricing' }" class="">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
            </li>
            <li>
              <h3>{{ $t("setup.label.ViewEvent") }}</h3>
            </li>
          </ul>
        </div>
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full md:w-full lg:w-full">
                <ul class="horizontal-sm-btn flex mb-2 float-right">
                  <li>
                    <div
                      class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                    >
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        class="truncate"
                        @click="editData(id)"
                        size="small"
                        >{{ $t("setup.label.Edit") }}</vs-button
                      >
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="truncate"
                        size="small"
                        @click="$router.push({ name: 'Add Price', params: { id: id } })"
                        >{{ $t("setup.label.AddPrice") }}</vs-button
                      >
                      <vs-button
                        color="danger"
                        icon-pack="feather"
                        icon="icon-x"
                        class="truncate"
                        size="small"
                        @click="deleteUserDataPopup = true"
                        >{{ $t("setup.label.Delete") }}</vs-button
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="block overflow-x-auto">
              <table class="table w-full table-bordered table-striped">
                <tr>
                  <td>
                    <b>{{ $t("setup.label.EventName") }}</b>
                  </td>
                  <td>{{ eventDataView.eventName }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.EventDescription") }}</b>
                  </td>
                  <td>{{ eventDataView.eventDescription }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.EventCategory") }}</b>
                  </td>
                  <td>{{ eventDataView.eventCategory }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.Status") }}</b>
                  </td>
                  <td>{{ eventDataView.statusId }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.StartDate") }}</b>
                  </td>
                  <td>{{ eventDataView.eventStartDate }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.ChargeCode") }}</b>
                  </td>
                  <td>{{ eventDataView.chargeCode }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.EndDate") }}</b>
                  </td>
                  <td>{{ eventDataView.eventEndDate }}</td>
                </tr>
              </table>
            </div>
          </vx-card>
        </div>
      </div>
      <delete-popup
        :deletePopup="deleteUserDataPopup"
        :title="$t('setup.label.Event')"
        @deletePressed="deleteUserData()"
        @cancelPressed="deleteUserDataPopup = false"
      >
      </delete-popup>
    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        deleteUserDataPopup: false,
      };
    },
  
    computed: {
      ...mapState({
        eventDataView: (state) => state.mediaDetails.eventViewById,
      }),
    },
    methods: {
      async getEventData() {
        try {
          await this.$store.dispatch(
            "mediaDetails/viewEventDataByIdAction",
            this.id
          );
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      },
      async deleteUserData() {
        try {
          await this.$store.dispatch(
            "mediaDetails/deleteEventAction",
            this.id
          );
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      },
      editData(id) {
        this.$router.push({ name: "Edit Event", params: { id: id } });
      },
    },
    filters: {},
    created() {
      this.id = this.$route.params.id;
      this.getEventData();
    },
  };
  </script>
  <style scoped>
  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    background-color: #fff;
    border: solid 1px #f0f0f0;
  }
  
  .table td {
    vertical-align: middle;
    border-top: none;
    padding: 10px 7px;
    font-size: 14px;
    color: #646a71;
    border-bottom: 1px solid #dfe3e7;
    transition: all 0.2s ease;
    overflow: hidden;
    word-break: break-all;
  }
  </style>
  